import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ParsedTimePipe } from './parsed-time.pipe';

@NgModule({
  declarations: [ParsedTimePipe],
  imports: [CommonModule],
  exports: [ParsedTimePipe],
})
export class ParsedTimeModule {}
